@if (retailerAttributesDefinitions) {
  <div class="container single-view" id="edit-retailer-attributes-definitions">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/retailer-attribute-definitions/' + retailerAttributeDefinitionId"
            class="inline-flex items-center text-base link link-icon left-arrow">
            {{ 'RETAILER_ATTRIBUTES_DEFINITIONS.BTN_BACK_TO_RETAILER_ATTRIBUTE_DEFINITIONS' | translate }}
          </a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-retailerattribute-title" class="section-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <app-attribute-definition-form
                #definitionForm
                mode="edit"
                formTestId="edit-retailerattribute-form"
                [definition]="retailerAttributesDefinitions"
                (submitted)="submitForm($event)">
              </app-attribute-definition-form>
              <!-- /main content -->
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-6 mb-4 pt-8 border-t">
              <div class="flex items-center justify-end gap-3">
                <button class="btn primary-btn" type="button" [disabled]="definitionForm.attributeDefinitionForm.invalid" (click)="definitionForm.submitForm()">
                  {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_UPDATE.BTN_SAVE_ATTRIBUTES' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
